<div
	class="flex flex-col justify-end relative w-full items-end bg-standard rounded-xl shadow-around outline outline-1 -outline-offset-1 outline-secondary-200 md:w-87.5 {{
		styleClasses()
	}}"
	[ngClass]="{ 'bg-primary-100!': type() === 'dark' }"
>
	@if (tagText()) {
		<ui-tag
			class="absolute top-3 right-3"
			[attr.data-cy]="'dashboard-box-tag'"
			[text]="tagText()"
			[type]="tagType()"
			[icon]="tagIcon()"
		></ui-tag>
	}
	<div class="h-full w-full flex flex-col px-6 pb-6 pt-12 justify-between">
		@if (image()) {
			<img [src]="image()" class="mx-auto mb-3 max-w-50" />
		}
		@if (title() || icon()) {
			<div class="flex flex-1 mb-4 items-center">
				<ui-icon [icon]="icon()" size="xl" class="mr-2" type="primary"></ui-icon>
				<span class="text-secondary-800 text-xl font-semibold">
					{{ title() }}
				</span>
			</div>
		}

		<ng-content select="[boxBody]"></ng-content>

		@if (buttonText()) {
			<ui-button
				[fullWidth]="true"
				[href]="href()"
				[route]="route()"
				[target]="target()"
				[text]="buttonText()"
				[type]="type() === 'dark' ? 'primary' : 'secondary'"
				(click)="emitClick()"
			></ui-button>
		}
	</div>
</div>
